export default __webpack_public_path__ + "static/media/BegaveLogo.2091eb21.png";